// src/components/search/NewsDetailModalContent.tsx

import React from 'react';
import { Stack, Box, Chip, Typography } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import { NewsArticle } from '@/types/news.types';

interface NewsDetailModalContentProps {
  newsItem: NewsArticle;
  imageUrl: string | null;
  formatDate: (dateString: string) => string;
}

export const NewsDetailModalContent: React.FC<NewsDetailModalContentProps> = ({
  newsItem,
  imageUrl,
  formatDate,
}) => (
  <Stack spacing={3}>
    <Box
      component="img"
      src={imageUrl || '/images/Logo.jpg'}
      alt={newsItem.title}
      onError={(e: any) => {
        e.target.src = '/images/Logo.jpg';
      }}
      sx={{
        width: '100%',
        height: { xs: 150, md: 250 },
        objectFit: 'cover',
        borderRadius: 2,
      }}
    />
    <Box sx={{ padding: '3rem' }}>
      <Chip
        label={newsItem.tag}
        sx={{
          mb: 2,
          backgroundColor: '#E8F5F3',
          color: 'primary.500',
        }}
      />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {newsItem.summary}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <CalendarToday sx={{ fontSize: 18, color: '#6b7280' }} />
        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          {formatDate(newsItem.date)}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{
          color: '#374151',
          lineHeight: 1.8,
          textAlign: 'justify',
          whiteSpace: 'pre-line',
        }}
      >
        {newsItem.content?.replace(/\n/g, '\n\n')}
      </Typography>
    </Box>
  </Stack>
);
